"use strict";
import "lodash";
import moment from "moment";
import { svc_addOne, svc_editOne, svc_fetchOne, svc_search } from "@/services";
import { showServerResponse } from "@/utils/message";
import { convertISODateTimeToString } from "@/utils/convertTime";
import config from "@/../config/config.json";

// need to change the endpointBasePrefix
const endpointBasePrefix = "mall-upload/config";

const Model = {
	namespace: "m_MallUploadConfig",
	state: {
		config: {},
		configs: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { configs } }) {
			return { ...state, configs };
		},
		handleFetchOne(state, { payload: { result } }) {
			return { ...state, config: result };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			if (payload.config_id) {
				payload.search = payload.config_id;
				delete payload.config_id;
			}

			let configs = yield call(svc_search, `${endpointBasePrefix}`, payload);

			_.forEach(configs.result, function (row) {
				row.key = row.id;
				row = convertISODateTimeToString(row, ["enabled_from"], config.dateFormat);

                row.upload_format_management = row.upload_format.split("_")[0];
			    row.upload_protocol = row.upload_format.split("_")[1];
                // if (!row.upos_terminal_id) row.terminal = { description: "ALL" };

				if (row.is_enabled)
					row.hideEnableBtn = true;
				if (!row.is_enabled)
					row.hideDisableBtn = true;
			});

			yield put({
				type: "handleFetchAll",
				payload: { configs },
			});

			return configs;
		},

		*addOne({ payload }, { call }) {
			payload = _.omit(payload, ["key"]);
			// convert enabled date before sending
			payload.enabled_from = moment(payload.enabled_from, config.dateFormat).format("YYYY-MM-DD");

			// format other values first
			if (payload.include && payload.include.length > 0) {
				if (payload.include.includes("TAX"))
					payload.include_tax = true;
				if (payload.include.includes("SERVICE_CHARGE"))
					payload.include_service_charge = true;
				if (payload.include.includes("VOID"))
					payload.include_void = true;
			}
			delete payload.include;

            if (payload.upos_outlet_id === "") delete payload.upos_outlet_id;
            if (payload.upos_terminal_id === "") delete payload.upos_terminal_id;

            payload.upload_format = `${payload.upload_format_management}_${payload.upload_protocol}`;
			delete payload.upload_format_management;
			delete payload.upload_protocol;

			let credentials = {
				host: payload?.host,
				username: payload?.username,
				password: payload?.password,
				port: payload?.port,
				path: payload?.path,
			};
			payload.credentials = JSON.stringify(credentials);
			delete payload.host;
			delete payload.username;
			delete payload.password;
			delete payload.port;
			delete payload.path;

			const response = yield call(svc_addOne, endpointBasePrefix, payload);
			return showServerResponse(response);
		},

		*editOne({ payload }, { call }) {
			payload = _.omit(payload, ["key"]);
			// convert enabled date before sending
			payload.enabled_from = moment(payload.enabled_from, config.dateFormat).format("YYYY-MM-DD");

			// format other values first
            payload.include_tax = false;
            payload.include_service_charge = false;
            payload.include_void = false;
			if (payload.include && payload.include.length > 0) {
				if (payload.include.includes("TAX"))
					payload.include_tax = true;
				if (payload.include.includes("SERVICE_CHARGE"))
					payload.include_service_charge = true;
				if (payload.include.includes("VOID"))
					payload.include_void = true;
			}
			delete payload.include;
            
            if (payload.upos_outlet_id === "") delete payload.upos_outlet_id;
            if (payload.upos_terminal_id === "") delete payload.upos_terminal_id;

            payload.upload_format = `${payload.upload_format_management}_${payload.upload_protocol}`;
			delete payload.upload_format_management;
			delete payload.upload_protocol;

			if (payload.credentials) {
				// no change to credentials
			} else {
				let credentials = {
					host: payload?.host,
					username: payload?.username,
					password: payload?.password,
                    port: payload?.port,
                    path: payload?.path,
				};
				payload.credentials = JSON.stringify(credentials);
			}
			delete payload.host;
			delete payload.username;
			delete payload.password;
			delete payload.port;
			delete payload.path;
			
			const response = yield call(svc_editOne, endpointBasePrefix, payload, "id");
			return showServerResponse(response);
		},
	},
	subscriptions: {},
};

export default Model;
